import { padronesModelsEnum } from 'views/Tramites/GPM/enums';

// constants
export const CLEAR = 'CLEAR';
export const SET_LADAS = 'CATALOGS__SET_LADAS';
export const SET_ESTADOS_GLOBALES = 'CATALOGS__SET_ESTADOS_GLOBALES';
export const SET_GENEROS = 'CATALOGS__SET_GENEROS';
export const SET_METODOS_DE_PAGO = 'CATALOGS__SET_METODOS_DE_PAGO';
export const SET_TIPOS_VIALIDADES = 'CATALOGS__SET_TIPOS_VIALIDADES';
export const SET_PAISES = 'CATALOGS__SET_PAISES';
export const SET_CUENTAS_CONTABLES = 'CATALOGS__SET_CUENTAS_CONTABLES';
export const SET_CONTENT_TYPES_PARTICIPIES = 'CATALOGS__SET_CONTENT_TYPES_PARTICIPIES';
export const SET_PERMISOS = 'CATALOGS__SET_PERMISOS';
export const SET_SECTORES_EMPRESARIALES = 'CATALOGS__SET_SECTORES_EMPRESARIALES';
export const SET_TIPO_DE_ESTABLECIMIENTO = 'CATALOGS__SET_TIPO_DE_ESTABLECIMIENTO';
export const SET_PADRONES = 'CATALOGS__SET_PADRONES';
export const SET_NATURALEZAS_DE_INGRESO = 'CATALOGS__SET_NATURALEZAS_DE_INGRESO';
export const SET_CLASIFICADORES_ECONOMICOS = 'CATALOGS__SET_CLASIFICADORES_ECONOMICOS';
export const SET_FUENTES = 'CATALOGS__SET_FUENTES';
export const SET_MESES = 'CATALOGS__SET_MESES';
export const SET_PERIODOS = 'CATALOGS__SET_PERIODOS';
export const SET_ESTADOS_CIVILES = 'CATALOGS__SET_ESTADOS_CIVILES';
export const SET_ESTADOS_DE_LOS_FUNCIONARIOS = 'CATALOGS__SET_ESTADOS_DE_LOS_FUNCIONARIOS';
export const SET_TIPOS_DE_APLICACION = 'CATALOGS__SET_TIPOS_DE_APLICACION';
export const SET_TIPOS_DE_APLICACION_CARGOS = 'CATALOGS__SET_TIPOS_DE_APLICACION_CARGOS';
export const SET_TIPOS_DE_DATO = 'CATALOGS__SET_TIPOS_DE_DATO';
export const SET_BANCOS = 'CATALOGS__SET_BANCOS';
export const SET_MONEDAS = 'CATALOGS__SET_MONEDAS';
export const SET_TIPOS_DE_APLICACION_DESCUENTOS = 'CATALOGS__SET_TIPOS_DE_APLICACION_DESCUENTOS';
export const SET_SERVICIOS_DEL_VEHICULO = 'CATALOGS__SET_SERVICIOS_DEL_VEHICULO';
export const SET_ESTADOS_DEL_VEHICULO = 'CATALOGS__SET_ESTADOS_DEL_VEHICULO';
export const SET_MARCAS_DE_VEHICULOS = 'CATALOGS__SET_MARCAS_DE_VEHICULOS';
export const SET_LINEAS_VEHICULARES = 'CATALOGS__SET_LINEAS_VEHICULARES';
export const SET_TIPOS_DE_VEHICULOS = 'CATALOGS__SET_TIPOS_DE_VEHICULOS';
export const SET_TIPOS_DE_MOTOCICLETAS = 'CATALOGS__SET_TIPOS_DE_MOTOCICLETAS';
export const SET_CLASES_DE_VEHICULOS = 'CATALOGS__SET_CLASES_DE_VEHICULOS';
export const SET_TIPOS_DE_ESTABLECIMIENTO = 'CATALOGS__SET_TIPOS_DE_ESTABLECIMIENTO';
export const SET_TIPOS_DE_PRESUPUESTOS = 'CATALOGS__SET_TIPOS_DE_PRESUPUESTOS';
export const SET_TIPOS_DE_EMPRESA = 'CATALOGS__SET_TIPOS_DE_EMPRESA';
export const SET_REGIMEN_DE_EMPRESA = 'CATALOGS__SET_REGIMEN_DE_EMPRESA';
export const SET_ESTADOS_DEL_NEGOCIO = 'CATALOGS__SET_ESTADOS_DEL_NEGOCIO';
export const SET_CLASIFICACIONES_DE_COMERCIO = 'CATALOGS__SET_CLASIFICACIONES_DE_COMERCIO';
export const SET_ESTATUS_DE_DEPOSITOS_EN_GARANTIA = 'CATALOGS__SET_ESTATUS_DE_DEPOSITOS_EN_GARANTIA';
export const SET_DIAS = 'CATALOGS__SET_DIAS';
export const SET_URS = 'CATALOGS__SET_URS';
export const SET_LLAVES_DE_PREDIOS = 'CATALOGS__SET_LLAVES_DE_PREDIOS';
export const SET_CONTENT_TYPES_PADRONES = 'CATALOGS__SET_CONTENT_TYPES_PADRONES';
export const SET_CATALOGOS_DE_REDONDEO = 'CATALOGS__SET_CATALOGOS_DE_REDONDEO';
export const SET_TIPOS_DE_CLAVES_DE_PREDIOS = 'CATALOGS__SET_TIPOS_DE_CLAVES_DE_PREDIOS';
export const SET_TIPOS_DE_PASOS_DE_TRAMITES = 'CATALOGS__SET_TIPOS_DE_PASOS_DE_TRAMITES';
export const SET_ESTADOS_DEL_PADRON = 'CATALOGS__SET_ESTADOS_DEL_PADRON';
export const SET_REGIMEN_DE_CAPITAL = 'CATALOGS__SET_REGIMEN_DE_CAPITAL';
export const SET_TIPOS_DE_PERSONAS = 'CATALOGS__SET_TIPOS_DE_PERSONAS';
export const SET_CATALOGO_DE_EFECTIVO = 'CATALOGS__SET_CATALOGO_DE_EFECTIVO';
export const SET_CLASES_DE_VENCIMIENTO = 'CATALOGS__SET_CLASES_DE_VENCIMIENTO';
export const SET_ESTADOS = 'CATALOGS__SET_ESTADOS';
export const SET_CATALOGO_ERRORES_WS = 'CATALOGS__SET_CATALOGO_ERRORES_WS';
export const SET_ORIENTACIONES_DE_PREDIOS = 'CATALOGS__SET_ORIENTACIONES_DE_PREDIOS';
export const SET_TIPOS_DE_PREDIOS = 'CATALOGS__SET_TIPOS_DE_PREDIOS';
export const SET_USOS_DE_PREDIO = 'CATALOGS__SET_USOS_DE_PREDIO';
export const SET_UNIDADES_DE_MEDIDA_PREDIOS = 'CATALOGS__SET_UNIDADES_DE_MEDIDA_PREDIOS';
export const SET_REGIMENES_DE_PROPIEDAD = 'CATALOGS__SET_REGIMENES_DE_PROPIEDAD';
export const SET_ACTUACIONES_PAE = 'CATALOGS__SET_ACTUACIONES_PAE';
export const SET_ESTADOS_DE_CREDITOS_PAE = 'CATALOGS__SET_ESTADOS_DE_CREDITOS_PAE';

const initialState = {
  ladas: [],
  estadosGlobales: [],
  generos: [],
  metodosDePago: [],
  tiposVialidades: [],
  paises: [],
  cuentasContables: [],
  contentTypesParticipies: [],
  permisos: [],
  sectoresEmpresariales: [],
  tipoDeEstablecimiento: [],
  padrones: [],
  naturalezasDeIngreso: [],
  clasificadoresEconomicos: [],
  fuentes: [],
  meses: [],
  periodos: [],
  estadosCiviles: [],
  estadosDeLosFuncionarios: [],
  tiposDeAplicacion: [],
  tiposDeAplicacionCargos: [],
  tiposDeDato: [],
  bancos: [],
  monedas: [],
  tiposDeAplicacionDescuentos: [],
  serviciosDelVehiculo: [],
  estadosDelVehiculo: [],
  marcasDeVehiculos: [],
  lineasVehiculares: [],
  tiposDeVehiculos: [],
  tiposDeMotocicletas: [],
  clasesDeVehiculos: [],
  tiposDeEstablecimiento: [],
  tiposPresupuestos: [],
  tiposDeEmpresa: [],
  regimenDeEmpresas: [],
  estadosDelNegocio: [],
  clasificacionesDeComercio: [],
  dias: [],
  urs: [],
  llavesDePredios: [],
  contentTypesPadrones: [],
  catalogosDeRedondeo: [],
  tiposDeClavesDePredios: [],
  tiposDePasosDeTramites: [],
  estadosDelPadron: [],
  regimenDeCapital: [],
  tiposDePersonas: [],
  catalogoDeEfectivo: [],
  clasesDeVencimiento: [],
  estados: [],
  catalogoErroresWS: [],
  orientacionesDePredios: [],
  tiposDePredios: [],
  usosDePredio: [],
  unidadesDeMedidaPredios: [],
  regimenesDePropiedad: [],
  actuacionesPae: [],
  estadosDeCreditosPae: [],
};

const formatPayload = (payload) => (Array.isArray(payload) ? payload : []);

const mapPadrones = (p) => ({ ...p, model: padronesModelsEnum[p.id] });

const getUpdatedState = (store, key, payload, mapper) => ({
  ...store,
  [key]: mapper ? formatPayload(payload).map(mapper) : formatPayload(payload),
});

// Action handlers
const setLadas = (state, payload) => getUpdatedState(state, 'ladas', payload);
const setEstadosGlobales = (state, payload) => getUpdatedState(state, 'estadosGlobales', payload);
const setTiposVialidades = (state, payload) => getUpdatedState(state, 'tiposVialidades', payload);
const setPaises = (state, payload) => getUpdatedState(state, 'paises', payload);
const setCuentasContables = (state, payload) => getUpdatedState(state, 'cuentasContables', payload);
const setMetodosDePago = (state, payload) => getUpdatedState(state, 'metodosDePago', payload);
const setContentTypesParticipies = (state, payload) => getUpdatedState(state, 'contentTypesParticipies', payload);
const setPermisos = (state, payload) => getUpdatedState(state, 'permisos', payload);
const setSectoresEmpresariales = (state, payload) => getUpdatedState(state, 'sectoresEmpresariales', payload);
const setTipoDeEstablecimiento = (state, payload) => getUpdatedState(state, 'tipoDeEstablecimiento', payload);
const setPadrones = (state, payload) => getUpdatedState(state, 'padrones', payload, mapPadrones);
const setNaturalezasDeIngreso = (state, payload) => getUpdatedState(state, 'naturalezasDeIngreso', payload);
const setClasificadoresEconomicos = (state, payload) => getUpdatedState(state, 'clasificadoresEconomicos', payload);
const setFuentes = (state, payload) => getUpdatedState(state, 'fuentes', payload);
const setTiposPresupuestos = (state, payload) => getUpdatedState(state, 'tiposPresupuestos', payload);
const setMeses = (state, payload) => getUpdatedState(state, 'meses', payload);
const setPeriodos = (state, payload) => getUpdatedState(state, 'periodos', payload);
const setGeneros = (state, payload) => getUpdatedState(state, 'generos', payload);
const setTiposDeEstablecimiento = (state, payload) => getUpdatedState(state, 'tiposDeEstablecimiento', payload);
const setServiciosDelVehiculo = (state, payload) => getUpdatedState(state, 'serviciosDelVehiculo', payload);
const setEstadosDelVehiculo = (state, payload) => getUpdatedState(state, 'estadosDelVehiculo', payload);
const setMarcasDeVehiculos = (state, payload) => getUpdatedState(state, 'marcasDeVehiculos', payload);
const setLineasVehiculares = (state, payload) => getUpdatedState(state, 'lineasVehiculares', payload);
const setTiposDeVehiculos = (state, payload) => getUpdatedState(state, 'tiposDeVehiculos', payload);
const setTiposDeMotocicletas = (state, payload) => getUpdatedState(state, 'tiposDeMotocicletas', payload);
const setClasesDeVehiculos = (state, payload) => getUpdatedState(state, 'clasesDeVehiculos', payload);
const setEstadosCiviles = (state, payload) => getUpdatedState(state, 'estadosCiviles', payload);
const setTiposDeAplicacion = (state, payload) => getUpdatedState(state, 'tiposDeAplicacion', payload);
const setTiposDeDato = (state, payload) => getUpdatedState(state, 'tiposDeDato', payload);
const setTiposDeAplicacionCargos = (state, payload) => getUpdatedState(state, 'tiposDeAplicacionCargos', payload);
const setTiposDeAplicacionDescuentos = (state, payload) => getUpdatedState(state, 'tiposDeAplicacionDescuentos', payload);
const setBancos = (state, payload) => getUpdatedState(state, 'bancos', payload);
const setEstadosDeLosFuncionarios = (state, payload) => getUpdatedState(state, 'estadosDeLosFuncionarios', payload);
const setTiposDeEmpresa = (state, payload) => getUpdatedState(state, 'tiposDeEmpresa', payload);
const setRegimenDeEmpresa = (state, payload) => getUpdatedState(state, 'regimenDeEmpresas', payload);
const setEstadosDelNegocio = (state, payload) => getUpdatedState(state, 'estadosDelNegocio', payload);
const setClasificacionesDeComercio = (state, payload) => getUpdatedState(state, 'clasificacionesDeComercio', payload);
const setUrs = (state, payload) => getUpdatedState(state, 'urs', payload);
const setMonedas = (state, payload) => getUpdatedState(state, 'monedas', payload);
const setDias = (state, payload) => getUpdatedState(state, 'dias', payload);
const setEstatusDeDepositosEnGarantia = (state, payload) => getUpdatedState(state, 'estadusDeDepositosEnGarantia', payload);
const setLlavesDePredios = (state, payload) => getUpdatedState(state, 'llavesDePredios', payload);
const setContentTypesPadrones = (state, payload) => getUpdatedState(state, 'contentTypesPadrones', payload);
const setCatalogosDeRedondeo = (state, payload) => getUpdatedState(state, 'catalogosDeRedondeo', payload);
const setTiposDeClavesDePredios = (state, payload) => getUpdatedState(state, 'tiposDeClavesDePredios', payload);
const setTiposDePasosDeTramites = (state, payload) => getUpdatedState(state, 'tiposDePasosDeTramites', payload);
const setEstadosDelPadron = (state, payload) => getUpdatedState(state, 'estadosDelPadron', payload);
const setRegimenDeCapital = (state, payload) => getUpdatedState(state, 'regimenDeCapital', payload);
const setTiposDePersonas = (state, payload) => getUpdatedState(state, 'tiposDePersonas', payload);
const setCatalogoDeEfectivo = (state, payload) => getUpdatedState(state, 'catalogoDeEfectivo', payload);
const setClasesDeVencimiento = (state, payload) => getUpdatedState(state, 'clasesDeVencimiento', payload);
const setEstados = (state, payload) => getUpdatedState(state, 'estados', payload);
const setErroresWS = (state, payload) => getUpdatedState(state, 'catalogoErroresWS', payload);
const setOrientacionesDePredios = (state, payload) => getUpdatedState(state, 'orientacionesDePredios', payload);
const setTiposDePredios = (state, payload) => getUpdatedState(state, 'tiposDePredios', payload);
const setUsosDePredio = (state, payload) => getUpdatedState(state, 'usosDePredio', payload);
const setUnidadesDeMedidaPredios = (state, payload) => getUpdatedState(state, 'unidadesDeMedidaPredios', payload);
const setRegimenesDePropiedad = (state, payload) => getUpdatedState(state, 'regimenesDePropiedad', payload);
const setActuacionesPae = (state, payload) => getUpdatedState(state, 'actuacionesPae', payload);
const setEstadosDeCreditosPae = (state, payload) => getUpdatedState(state, 'estadosDeCreditosPae', payload);
const clear = () => ({ ...initialState });

const ACTION_HANDLER = {
  [SET_LADAS]: setLadas,
  [SET_ESTADOS_GLOBALES]: setEstadosGlobales,
  [SET_TIPOS_VIALIDADES]: setTiposVialidades,
  [SET_CUENTAS_CONTABLES]: setCuentasContables,
  [SET_CONTENT_TYPES_PARTICIPIES]: setContentTypesParticipies,
  [SET_PERMISOS]: setPermisos,
  [SET_SECTORES_EMPRESARIALES]: setSectoresEmpresariales,
  [SET_TIPO_DE_ESTABLECIMIENTO]: setTipoDeEstablecimiento,
  [SET_PADRONES]: setPadrones,
  [SET_NATURALEZAS_DE_INGRESO]: setNaturalezasDeIngreso,
  [SET_CLASIFICADORES_ECONOMICOS]: setClasificadoresEconomicos,
  [SET_FUENTES]: setFuentes,
  [SET_MESES]: setMeses,
  [SET_URS]: setUrs,
  [SET_PERIODOS]: setPeriodos,
  [SET_GENEROS]: setGeneros,
  [SET_ESTADOS_CIVILES]: setEstadosCiviles,
  [SET_ESTADOS_DE_LOS_FUNCIONARIOS]: setEstadosDeLosFuncionarios,
  [SET_TIPOS_DE_APLICACION]: setTiposDeAplicacion,
  [SET_TIPOS_DE_APLICACION_CARGOS]: setTiposDeAplicacionCargos,
  [SET_TIPOS_DE_DATO]: setTiposDeDato,
  [SET_METODOS_DE_PAGO]: setMetodosDePago,
  [SET_BANCOS]: setBancos,
  [SET_MONEDAS]: setMonedas,
  [SET_TIPOS_DE_APLICACION_DESCUENTOS]: setTiposDeAplicacionDescuentos,
  [SET_TIPOS_DE_ESTABLECIMIENTO]: setTiposDeEstablecimiento,
  [SET_SERVICIOS_DEL_VEHICULO]: setServiciosDelVehiculo,
  [SET_ESTADOS_DEL_VEHICULO]: setEstadosDelVehiculo,
  [SET_MARCAS_DE_VEHICULOS]: setMarcasDeVehiculos,
  [SET_LINEAS_VEHICULARES]: setLineasVehiculares,
  [SET_TIPOS_DE_VEHICULOS]: setTiposDeVehiculos,
  [SET_TIPOS_DE_MOTOCICLETAS]: setTiposDeMotocicletas,
  [SET_CLASES_DE_VEHICULOS]: setClasesDeVehiculos,
  [SET_TIPOS_DE_PRESUPUESTOS]: setTiposPresupuestos,
  [SET_TIPOS_DE_EMPRESA]: setTiposDeEmpresa,
  [SET_REGIMEN_DE_EMPRESA]: setRegimenDeEmpresa,
  [SET_ESTADOS_DEL_NEGOCIO]: setEstadosDelNegocio,
  [SET_CLASIFICACIONES_DE_COMERCIO]: setClasificacionesDeComercio,
  [SET_ESTATUS_DE_DEPOSITOS_EN_GARANTIA]: setEstatusDeDepositosEnGarantia,
  [SET_DIAS]: setDias,
  [SET_PAISES]: setPaises,
  [SET_LLAVES_DE_PREDIOS]: setLlavesDePredios,
  [SET_CONTENT_TYPES_PADRONES]: setContentTypesPadrones,
  [SET_CATALOGOS_DE_REDONDEO]: setCatalogosDeRedondeo,
  [SET_TIPOS_DE_CLAVES_DE_PREDIOS]: setTiposDeClavesDePredios,
  [SET_TIPOS_DE_PASOS_DE_TRAMITES]: setTiposDePasosDeTramites,
  [SET_ESTADOS_DEL_PADRON]: setEstadosDelPadron,
  [SET_REGIMEN_DE_CAPITAL]: setRegimenDeCapital,
  [SET_TIPOS_DE_PERSONAS]: setTiposDePersonas,
  [SET_CATALOGO_DE_EFECTIVO]: setCatalogoDeEfectivo,
  [SET_CLASES_DE_VENCIMIENTO]: setClasesDeVencimiento,
  [SET_ESTADOS]: setEstados,
  [SET_CATALOGO_ERRORES_WS]: setErroresWS,
  [SET_ORIENTACIONES_DE_PREDIOS]: setOrientacionesDePredios,
  [SET_TIPOS_DE_PREDIOS]: setTiposDePredios,
  [SET_USOS_DE_PREDIO]: setUsosDePredio,
  [SET_UNIDADES_DE_MEDIDA_PREDIOS]: setUnidadesDeMedidaPredios,
  [SET_REGIMENES_DE_PROPIEDAD]: setRegimenesDePropiedad,
  [SET_ACTUACIONES_PAE]: setActuacionesPae,
  [SET_ESTADOS_DE_CREDITOS_PAE]: setEstadosDeCreditosPae,
  [CLEAR]: clear,
};

export default (state = initialState, action) => {
  const handler = ACTION_HANDLER[action.type];
  return handler ? handler(state, action.payload) : state;
};
